import { useRequestDeleteUser } from '@/hooks/httpRequest';
import { confirm } from '../../../react-confirm/Confirm';
import { IHas_Id, IUserData } from '@/lib/interface';
import { emptyFunction, notify } from '@/functions';
import { UserAccountStatusEnum } from '@/enums';
import { useNavigate } from 'react-router-dom';
import UserCard from '../../../userCard';
import Loader from '../../../Loader';
import routes from '@/lib/routes';
import { TTabname } from '../..';

type TProps = {
	user: IUserData;
}

const ProfileDetailUserDataSubAccountsItemViewCard = ({ user }: TProps) => {

	const { triggerDeleteUser, isLoadingDeleteUser } = useRequestDeleteUser();
	const navigate = useNavigate();

	const handleOnClickBtnDelete = (user: IHas_Id & { username: string; }) =>
		confirm(
			<span>
				Etes-vous sûr de vouloir supprimer le compte <span className='text-purple-600 font-medium'>{user.username}</span> ?
			</span>
		)
			.then(
				yes => yes &&
					triggerDeleteUser({ userId: user._id })
						.then(() => notify('Le profil a été supprimé avec succès.'))
			)
			.catch(emptyFunction);

	const handleOnClickBtnSee = (user: IHas_Id) =>
		navigate(
			{
				search: new URLSearchParams({ tab: 'subAccounts' as TTabname }).toString(),
				pathname: routes.nav.users.single.getHref(user._id),
			},
			{ replace: true }
		);

	if (isLoadingDeleteUser) {
		return (
			<div className='my-10'>
				<Loader className='my-10' />
			</div>
		);
	}

	return (
		<UserCard
			className='w-full md:w-full'
			onClickBtnSee={handleOnClickBtnSee}
			onClickBtnDelete={(
				user.accountStatus !== UserAccountStatusEnum.ADMIN_DELETED
					? handleOnClickBtnDelete
					: undefined
			)}
			user={({
				...user,
				photo: user.pictures?.[0]?.path
			})} />
	);

};

export default ProfileDetailUserDataSubAccountsItemViewCard;
